/**
 * O JOB DE AUTOMAÇÃO COMO VEM DA LISTA (19/10/2026, backend #491). `GET /procurement/automation/jobs` devolvia o job
 * inteiro (1,43 MB a cada 20 s no polling da tela de propostas); agora devolve o formato enxuto `JobDeAutomacaoEnxuto`.
 * O DETALHE (`GET …/jobs/:id`) não mudou: logs, screenshots e `data.fillItemsResult` continuam só nele.
 *
 * ⛔ A tela não lê da lista nada que só exista no detalhe; quem precisa do resto abre o detalhe (`getAutomationJob`).
 * O `updatedAt` entra no enxuto a pedido (Maestro, 19/10: a primeira versão do #491 não o trazia, e o histórico ficaria
 * sem hora); a hora exibida é ele, e o `createdAt` só na falta dele (`quandoDoJob`).
 */
export interface JobDaLista {
  id: number;
  proposalId: number | null;
  action: string | null;
  portal: string | null;
  status: string | null;
  /** Simulação (teste) só quando `true`: null/ausente é envio de verdade (ver `ehSimulacao`). */
  dryRun: boolean | null;
  errorMessage: string | null;
  protocolNumber: string | null;
  createdAt: string | null;
  /** A hora exibida (ver `quandoDoJob`). Opcional: some do enxuto só se o backend voltar atrás. */
  updatedAt?: string | null;
  steps: any[];
  /** No TOPO e só quando existe (no detalhe ele mora em `data.fillItemsResult`). */
  fillItemsResult?: any;
  proposal: {
    id: number;
    itemId: number | null;
    title: string | null;
    totalValue: number | string | null;
    item: { id: number; portalOrigem: string | null; linkOrigem: string | null } | null;
  } | null;
}

/** O selo "(teste)": só com `dryRun === true`. Null, ausente ou qualquer outra coisa é envio de verdade. */
export const ehSimulacao = (j: { dryRun?: unknown } | null | undefined): boolean => j?.dryRun === true;

/** A hora do job, como sempre foi: a da última atualização, e a de criação só quando ela não vem. */
export const quandoDoJob = (j: { updatedAt?: string | null; createdAt?: string | null } | null | undefined): string | null =>
  j?.updatedAt || j?.createdAt || null;
